import * as React from 'react'
import ProductPicture from '../ProductPicture'
/**
 * @param {ImageSelectorProps} props - The component props.
 * @returns {JSX.Element} - The rendered component.
 */
const ImageSelector = ({ productTitle, imageUrls }) => {
  const [activeSlideIndex, setActiveSlide] = React.useState(0)
  const shownImageUrl = imageUrls[activeSlideIndex]

  return (
    <div className="product-image_grid">
      <div className="product-thumbs">
        {(imageUrls.length >= 1 ? imageUrls : [null]).map((url, i) => {
          const isActive = activeSlideIndex === i

          return (
            <button
              type="button"
              // eslint-disable-next-line react/no-array-index-key
              key={`image_${i}`}
              className={`product-thumbs__item ${
                isActive && 'product-thumbs__item--active'
              }`}
              onClick={() => {
                setActiveSlide(i)
              }}
            >
              <ProductPicture
                title={`${productTitle} Thumbnail`}
                src={url}
                width={200}
              />
            </button>
          )
        })}
      </div>
      <div
        className="product-images__item"
        {...(activeSlideIndex > 0 ? { 'data-nosnippet': true } : {})}
      >
        <ProductPicture title={productTitle} src={shownImageUrl} width={1200} />
      </div>
    </div>
  )
}

/**
 * @typedef {{
 *  productTitle:string
 *  imageUrls: Array<string>
 * }} ImageSelectorProps
 */

export default ImageSelector
